import React, { useMemo, useState } from "react";
import {
  TreeList,
  mapTree,
  extendDataItem,
  createDataTree
} from "@progress/kendo-react-treelist";

import { NormalCell , ToggleCell  } from "./cells/normal-cell"

import "./tree-list.css"

const GenericTreeList = ({
  data = [],
  idField = "id",
  parentIdField = "parentId",
  subItemsField = "items",
  height ="100%",
  columnType
}) => {
  const [expandedState, setExpandedState] = useState({});
  const [selectedState, setSelectedState] = useState({});

  /* -----------------------------
     1️⃣ Flat → Tree (GENERIC)
  ----------------------------- */
  const treeData = useMemo(() => {
    return createDataTree(
      data,
      (item) => item[idField],
      (item) => item[parentIdField],
      subItemsField
    );
  }, [data, idField, parentIdField, subItemsField]);

  /* -----------------------------
     2️⃣ Attach UI state (GENERIC)
  ----------------------------- */
  const extendedData = useMemo(() => {
    return mapTree(treeData, subItemsField, (item) =>
      extendDataItem(item, subItemsField, {
        expanded: expandedState[item[idField]],
        selected: selectedState[item[idField]]
      })
    );
  }, [treeData, expandedState, selectedState, idField, subItemsField]);

  /* -----------------------------
     3️⃣ Expand Handler
  ----------------------------- */
  const handleExpandChange = (event) => {
    const item = event.dataItem;
    const id = item[idField];

    setExpandedState((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  /* -----------------------------
     4️⃣ Selection Handler
  ----------------------------- */
  const handleSelectionChange = (event) => {
    const item = event.dataItem;
    const id = item[idField];

    setSelectedState({
      [id]: !selectedState[id]
    });
  };


  const DataSchemaColumns = [
    {
      field: "Name",
      title: "Domains",
      expandable: true,
      width:600,
      cell:( event ) => <NormalCell event={event} subItemsField = { subItemsField } handleSelectionChange = { handleSelectionChange } handleExpandChange = {handleExpandChange }/>
    },
    {
      field: "",
      title: "Abbreviation",
      expandable: true ,
      cell : ( event ) => <td>{ event.dataItem.Abbreviation }</td>  
     },
    {
      field: "",
      title: "Data Type",
      expandable: true ,
      cell : (event) => <td>{ event.dataItem.DataType }</td>  
     },
    {
      field: "",
      title: "Required",
      expandable: true ,
      cell : (event) => <ToggleCell event={event}/>  
     },
  ];

  const SapColumns = [
    {
      field: "Name",
      title: "Domains",
      expandable: true,
      width:400,
      cell:( event ) => <NormalCell event={event} subItemsField = { subItemsField } handleSelectionChange = { handleSelectionChange } handleExpandChange = {handleExpandChange }/>
    },
    {
      field: "",
      title: "Abbreviation",
      expandable: true ,
       width:300,
      cell : ( event ) => <td>{ event.dataItem.Abbreviation }</td>  
     },
    {
      field: "",
      title: "Data Type",
      expandable: true ,
       width:300,
      cell : (event) => <td>{ event.dataItem.DataType }</td>  
     },
    {
      field: "",
      title: "Multiple Selection",
      expandable: true ,
      width:300,
      cell : (event) => <ToggleCell event={event}/>  
     },
    {
      field: "",
      title: "Required",
      expandable: true ,
      width:300,
      cell : (event) => <ToggleCell event={event}/>  
     },
  ];
  
   const setColumns = ( )=>{
      if( columnType === "DataSchema" )
        return DataSchemaColumns
      else if ( columnType === "SapMethod" )
         return SapColumns
      else 
        return []
  }

  return (
    <TreeList
      style={{ height }}
      data={extendedData}
      subItemsField={subItemsField}
      expandField="expanded"
      selectedField="selected"
      columns={setColumns()}
      onExpandChange={handleExpandChange}
      onSelectionChange={handleSelectionChange}
    />
  );
};

export default GenericTreeList;